import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { CssGrid } from "styles/helpers/layout";

export const StyledProgressBarWrapper = styled(CssGrid)<Props>`
  font-size: ${(props: Props) => props.theme.font.size._14};
  align-items: center;
  grid-gap: 10px;
`;
